// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_BuscarCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /agenda/buscar_compromisso
 *
 * Returns a compromisso with full details including the associated orcamento
 * (with its services list) and any ocorrencias linked to the compromisso.
 *
 * Row shapes:
 *   - $orcamento — see Agenda_BuscarCompromissoOrcamentoRow (wrapper around
 *     orcamento details + servicos list).
 *   - $compromisso — see Agenda_BuscarCompromissoRow (single enriched
 *     compromisso row with operador and servicos_compromisso).
 *   - $ocorrencias — currently always emitted as an empty array; controller
 *     wires `$ocorrencias = array()` directly.
 *
 * @see Agenda_BuscarCompromissoOrcamentoRow
 * @see Agenda_BuscarCompromissoRow
 */
import type { Agenda_BuscarCompromissoOrcamentoRow } from './Agenda_BuscarCompromissoOrcamentoRow'
import type { Agenda_BuscarCompromissoRow } from './Agenda_BuscarCompromissoRow'
import type { Ocorrencias_BuscarOcorrenciasRow } from './Ocorrencias_BuscarOcorrenciasRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Agenda_BuscarCompromissoResponseDados {
ocorrencias: Ocorrencias_BuscarOcorrenciasRow[]
orcamento?: Agenda_BuscarCompromissoOrcamentoRow
compromisso?: Agenda_BuscarCompromissoRow
}

export type Agenda_BuscarCompromissoResponse = ApiResponse<Agenda_BuscarCompromissoResponseDados>;

registerResponseContract('Agenda_BuscarCompromissoResponse', {
  ocorrencias: {
    type: 'array',
    required: true,
    items: {
      ID:        { type: 'string',  required: false },
      Owner:     { type: 'string',  required: false },
      OwnerID:   { type: 'number',  required: false },
      Content:   { type: 'string',  required: false },
      User:      { type: 'string',  required: false },
      CreatedAt: { type: 'string',  required: false },
    },
  },
  orcamento: {
    type: 'object',
    required: false,
    fields: {
      orcamento: {
        type: 'object',
        required: false,
        fields: {
          orcamento_id:              { type: 'number',  required: true },
          orcamento_franquia_id:     { type: 'number',  required: true },
          orcamento_user_id:         { type: 'string',  required: true },
          orcamento_location_id:     { type: 'number',  required: false },
          orcamento_location_type:   { type: 'string',  required: false },
          orcamento_valor:           { type: 'number',  required: true },
          orcamento_origem:          { type: 'number',  required: false },
          orcamento_data:            { type: 'string',  required: false },
          orcamento_status:          { type: 'string',  required: true },
          orcamento_status_label:    { type: 'string',  required: false },
          orcamento_observacao:      { type: 'string',  required: false },
          orcamento_cliente_id:      { type: 'number',  required: false },
          orcamento_nome_cliente:    { type: 'string',  required: false },
          orcamento_rua:             { type: 'string',  required: false },
          orcamento_cep:             { type: 'string',  required: false },
          orcamento_numero:          { type: 'string',  required: false },
          orcamento_bairro:          { type: 'string',  required: false },
          orcamento_ddi:             { type: 'string',  required: false },
          orcamento_ddd:             { type: 'string',  required: false },
          orcamento_telefone:        { type: 'string',  required: false },
          orcamento_complemento:     { type: 'string',  required: false },
          mostrar_telefone_agenda:   { type: 'boolean', required: false },
          orcamento_franquia_nome:   { type: 'string',  required: false },
          orcamento_localidade_nome: { type: 'string',  required: false },
        },
      },
      servicos: {
        type: 'array',
        required: false,
        items: {
          orcamento_servico_id:            { type: 'number',  required: true },
          orcamento_id:                    { type: 'number',  required: true },
          servico_id:                      { type: 'number',  required: true },
          servico_valor:                   { type: 'number',  required: true },
          orcamento_servico_user_id:       { type: 'string',  required: false },
          orcamento_servico_tipo:          { type: 'number',  required: false },
          orcamento_servico_status:        { type: 'number',  required: true },
          orcamento_servico_qtd:           { type: 'number',  required: true },
          orcamento_servico_data_cadastro: { type: 'string',  required: false },
          servico_nome:                    { type: 'string',  required: true },
        },
      },
    },
  },
  compromisso: {
    type: 'object',
    required: false,
    fields: {
      compromisso_id:                    { type: 'number',  required: true },
      compromisso_titulo:                { type: 'string',  required: false },
      title:                             { type: 'string',  required: false },
      compromisso_total:                 { type: 'string',  required: false },
      backgroundColor:                   { type: 'string',  required: false },
      compromisso_data_hora_inicio:      { type: 'string',  required: false },
      start:                             { type: 'string',  required: false },
      compromisso_data_hora_fim:         { type: 'string',  required: false },
      end:                               { type: 'string',  required: false },
      compromisso_data_cadastro:         { type: 'string',  required: false },
      compromisso_operador_user_id:      { type: 'string',  required: false },
      compromisso_orcamento_id:          { type: 'number',  required: false },
      compromisso_franquia_id:           { type: 'number',  required: false },
      compromisso_forma_pagamento:       { type: 'number',  required: false },
      compromisso_forma_pagamento_label: { type: 'string',  required: false },
      compromisso_numero_parcelas:       { type: 'number',  required: false },
      compromisso_nome_cliente:          { type: 'string',  required: false },
      compromisso_observacao:            { type: 'string',  required: false },
      compromisso_origem:                { type: 'number',  required: false },
      compromisso_status:                { type: 'string',  required: true },
      compromisso_status_original:       { type: 'string',  required: true },
      compromisso_tipo:                  { type: 'number',  required: false },
      compromisso_checkin:               { type: 'string',  required: false },
      compromisso_checkout:              { type: 'string',  required: false },
      compromisso_entrou_sem_problemas:  { type: 'number',  required: false },
      compromisso_status_financeiro:     { type: 'number',  required: false },
      compromisso_foi_reagendado:        { type: 'number',  required: false },
      compromisso_valor_recebido:        { type: 'string',  required: false },
      cliente_id:                        { type: 'number',  required: true },
      cliente_location_id:               { type: 'number',  required: false },
      cliente_location_type:             { type: 'string',  required: false },
      cliente:                           { type: 'string',  required: true },
      franquia_nome:                     { type: 'string',  required: false },
      localidade:                        { type: 'string',  required: false },
      status_financeiro:                 { type: 'string',  required: false },
      operador: {
        type: 'object',
        required: false,
        fields: {
          first_name: { type: 'string',  required: true },
          image:      { type: 'string',  required: true },
        },
      },
      servicos:                          { type: 'string',  required: false },
      servicos_compromisso: {
        type: 'array',
        required: false,
        items: {
          servicoscategoria_id:              { type: 'number',  required: true },
          servico_id:                        { type: 'number',  required: true },
          compromisso_servico_id:            { type: 'number',  required: true },
          compromisso_id:                    { type: 'number',  required: false },
          orcamento_servico_id:              { type: 'number',  required: false },
          compromisso_servico_status:        { type: 'number',  required: true },
          compromisso_servico_valor:         { type: 'number',  required: true },
          compromisso_servico_qtd:           { type: 'number',  required: true },
          compromisso_servico_data_cadastro: { type: 'string',  required: false },
          compromisso_servico_observacao:    { type: 'string',  required: false },
          servico_nome:                      { type: 'string',  required: true },
          tem_imagens_antes:                 { type: 'boolean', required: false },
          tem_imagens_depois:                { type: 'boolean', required: false },
          imagens:                           { type: 'string',  required: false },
        },
      },
      nome_operador:                     { type: 'string',  required: false },
      avatar_operador:                   { type: 'string',  required: false },
      borderColor:                       { type: 'string',  required: false },
      compromisso_valor_total:           { type: 'number',  required: false },
      valor_restante:                    { type: 'number',  required: false },
      valor_total:                       { type: 'number',  required: false },
      franchise_id:                      { type: 'number',  required: false },
    },
  },
})
